import {
  CREATE_VARIANT_FAILURE,
  CREATE_VARIANT_REQUEST,
  GET_ALL_VARIANT_REQUEST,
  GET_ALL_VARIANT_SUCCESS,
  GET_ALL_VARIANT_FAILURE,
  DELETE_VARIANT_REQUEST,
  DELETE_VARIANT_FAILURE,
  UPDATE_VARIANT_REQUEST,
  UPDATE_VARIANT_FAILURE,
  CREATE_VARIANT_SUCCESS,
  DELETE_VARIANT_SUCCESS,
  UPDATE_VARIANT_SUCCESS,
} from "./ActionType";

const initialState = {
  variants: [],
  variant: null,
  loading: false,
  error: "",
};

export const vendorProductVariantReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_VARIANT_REQUEST:
      return { ...state, loading: true };

    case CREATE_VARIANT_SUCCESS:
      return { ...state, loading: false, error: "", variant: action.payload };

    case CREATE_VARIANT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_VARIANT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_VARIANT_SUCCESS:
      return { ...state, loading: false, error: "", variants: action.payload };

    case GET_ALL_VARIANT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_VARIANT_REQUEST:
      return { ...state, loading: true };

    case DELETE_VARIANT_SUCCESS:
      return { ...state, loading: false, error: "", variant: action.payload };

    case DELETE_VARIANT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_VARIANT_REQUEST:
      return { ...state, loading: true };

    case UPDATE_VARIANT_SUCCESS:
      return { ...state, loading: false, error: "", variant: action.payload };

    case UPDATE_VARIANT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
